<template>
    <div class="fuel container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>TREASURY OVERVIEW</h4>
			</div>

            <div class="col-md-12 mb-2">
                <el-form label-position="top" label-width="100px" class="ml-0">
                    <div class="row">
                        <div class="col-md-2">
                            <el-form-item label="">
                                <el-select v-model="filter.month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="">
                                <el-select v-model="filter.year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2" v-if="false">
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>

			<div class="col-md-12 mb-2">
                <el-card shadow="none" class="box-card col-md-12 mb-4 p-0">
                    <div class="mb-3 text-center">
                        <h5>POSISI KAS HARIAN</h5>
                    </div>
                    <div>
                        <mixed-chart :rawData="chartItems"></mixed-chart>
                        <Loader v-if="loading.chart"/>
                    </div>
                </el-card>
			</div>

            <div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12 mb-0">
                        <el-card shadow="none" class="box-card col-md-12 mb-4 p-0">
                            <div class="mb-3 text-center">
                                <h5>NERACA (Jt)</h5>
                            </div>
                            <hr class="pb-0 mb-1">
                            <div style="width:100%;overflow-x: auto;">
                                <table class="table-striped table-hover table-financial-ratio" style="width: 100%;">
                                    <thead>
                                        <tr>
                                            <th style="min-width: 200px;">Neraca</th>
                                            <th class="text-center">Jan</th>
                                            <th class="text-center">Ytd Feb</th>
                                            <th class="text-center">Ytd Mar</th>
                                            <th class="text-center">Ytd Apr</th>
                                            <th class="text-center">Ytd May</th>
                                            <th class="text-center">Ytd Jun</th>
                                            <th class="text-center">Ytd Jul</th>
                                            <th class="text-center">Ytd Aug</th>
                                            <th class="text-center">Ytd Sep</th>
                                            <th class="text-center">Ytd Oct</th>
                                            <th class="text-center">Ytd Nov</th>
                                            <th class="text-center">Ytd Dec</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in balanceSheet" :key="item.Category">
                                            <td>{{ item.Name }}</td>
                                            <td class="text-right">{{ formatNum(item.Jan) }}</td>
                                            <td class="text-right">{{ formatNum(item.Feb) }}</td>
                                            <td class="text-right">{{ formatNum(item.Mar) }}</td>
                                            <td class="text-right">{{ formatNum(item.Apr) }}</td>
                                            <td class="text-right">{{ formatNum(item.May) }}</td>
                                            <td class="text-right">{{ formatNum(item.Jun) }}</td>
                                            <td class="text-right">{{ formatNum(item.Jul) }}</td>
                                            <td class="text-right">{{ formatNum(item.Aug) }}</td>
                                            <td class="text-right">{{ formatNum(item.Sep) }}</td>
                                            <td class="text-right">{{ formatNum(item.Oct) }}</td>
                                            <td class="text-right">{{ formatNum(item.Nov) }}</td>
                                            <td class="text-right">{{ formatNum(item.Dec) }}</td>
                                        </tr>

                                        <tr v-if="!balanceSheet?.length && !loading.table">
                                            <td colspan="13" class="text-center">No Data</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Loader v-if="loading.table"/>
                            </div>
                            <hr class="p-0 m-0">
                        </el-card>
					</div>
				</div>
			</div>

            <div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12 mb-0">
                        <el-card shadow="none" class="box-card col-md-12 mb-4 p-0">
                            <div class="mb-3 text-center">
                                <h5>RASIO KEUANGAN</h5>
                            </div>
                            <hr class="pb-0 mb-1">
                            <div style="width:100%;overflow-x: auto;">
                                <table class="table-striped table-hover table-financial-ratio" style="width: 100%;">
                                    <thead>
                                        <tr>
                                            <th style="min-width: 200px;">Rasio Keuangan</th>
                                            <th class="text-center">Jan</th>
                                            <th class="text-center">Ytd Feb</th>
                                            <th class="text-center">Ytd Mar</th>
                                            <th class="text-center">Ytd Apr</th>
                                            <th class="text-center">Ytd May</th>
                                            <th class="text-center">Ytd Jun</th>
                                            <th class="text-center">Ytd Jul</th>
                                            <th class="text-center">Ytd Aug</th>
                                            <th class="text-center">Ytd Sep</th>
                                            <th class="text-center">Ytd Oct</th>
                                            <th class="text-center">Ytd Nov</th>
                                            <th class="text-center">Ytd Dec</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in financialRatio" :key="item.Category">
                                            <td>{{ item.Category }}</td>
                                            <td class="text-right">{{ formatNum(item.Jan) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Feb) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Mar) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Apr) }} %</td>
                                            <td class="text-right">{{ formatNum(item.May) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Jun) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Jul) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Aug) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Sep) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Oct) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Nov) }} %</td>
                                            <td class="text-right">{{ formatNum(item.Dec) }} %</td>
                                        </tr>
                                        <tr v-if="!financialRatio?.length && !loading.ratio">
                                            <td colspan="13" class="text-center">No Data</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Loader v-if="loading.ratio"/>
                            </div>
                            <hr class="p-0 m-0">
                        </el-card>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import PieChart from '@/components/chart/Pie.js'
import Loader from '@/components/loader/Loader2.vue'
import { Config,Penanggalan, AxiosWithJar, FuelColor, Rainbow, Rainbow2, AppColors } from '@/utility.js'
//import ChartSalesMonthComparisonBySalesArea from '@/views/pages/PPOB/Component/ChartSalesMonthComparisonBySalesArea.vue'
import MixedChart from './Overview/ChartPosisiKashHarian.vue'


export default{
	extends: Treasury,
	components:{
        MixedChart,
        Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
	},
	data() {
		return {
            value: 0,
            isChildRoute: false,
            financialRatio: [],
            balanceSheet: [],
            filter: {
                year: ""+Penanggalan().tahun,
                month: (Penanggalan().bulan),
            },
            options: {
                group:[
					{ value: 'current', name: 'CURRENT' },
					{ value: 'ytd', name: 'YTD' },
				],
                months:[
                    //{value:'', name: 'All/Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                    {value:'2026', name: '2026'},
                ],
            },

            loading: {
                table: false,
                chart: false,
                ratio: false,
                isSuccess: false,
            },

            chartItems: [
                {
                StmtDate: "2025-07-01",
                OpeningBalance: 1000000,
                ClosingBalance: 1200000,
                CashIn: 50000,
                CashOut: 30000
                },
                {
                StmtDate: "2025-07-02",
                OpeningBalance: 1200000,
                ClosingBalance: 1250000,
                CashIn: 40000,
                CashOut: 35000
                }
            ]
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        },
         'filter.year'(newVal, oldVal) {
            //console.log('Year changed:', newVal);
            this.getPosisiKashHarian();
            this.getFinancialRatio();
            this.getBalanceSheet();
        },
        'filter.month'(newVal, oldVal) {
            //console.log('Month changed:', newVal);
            this.getPosisiKashHarian();
        },
        'filter.type'(newVal, oldVal) {
            //console.log('Type changed:', newVal);
            this.getPosisiKashHarian();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
        this.getPosisiKashHarian();
        this.getFinancialRatio();
        this.getBalanceSheet();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/treasury-overview';
        },

        async getPosisiKashHarian() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/posisikasharian?'
            //
            this.urlRequestParams+='&year='+this.filter.year
			this.urlRequestParams+='&month='+this.filter.month
			//this.urlRequestParams+='&type='+this.filter.type

			this.loading.chart = true
			//this.loading.table = true
			this.loading.isSuccess = false;

			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.responsedata = response.data;
					this.loading.isSuccess = true;

                    this.chartItems = this.responsedata.data;

                    //console.log('this.responsedata: ' + JSON.stringify(this.responsedata.data.arus_kas_operasi));
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					//this.loading.table = false;
					this.loading.chart = false;
				})
        },

        async getFinancialRatio() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/financialRatioOverview?'
            //
            this.urlRequestParams+='&year='+this.filter.year
			this.urlRequestParams+='&month='+this.filter.month
			//this.urlRequestParams+='&type='+this.filter.type

			this.loading.ratio = true
			//this.loading.table = true
			//this.loading.isSuccess = false;

			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.responsedata = response.data;
					this.loading.isSuccess = true;

                    this.financialRatio = this.responsedata.data;

                    //console.log('this.responsedata: ' + JSON.stringify(this.responsedata.data.arus_kas_operasi));
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.ratio = false;
					//this.loading.chart = false;
				})
        },

        async getBalanceSheet() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/balancesheet?'
            //
            this.urlRequestParams+='&year='+this.filter.year
			this.urlRequestParams+='&month='+this.filter.month
			//this.urlRequestParams+='&type='+this.filter.type

			//this.loading.chart = true
			this.loading.table = true
			//this.loading.isSuccess = false;

			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.responsedata = response.data;
					this.loading.isSuccess = true;

                    this.balanceSheet = this.responsedata.data;

                    //console.log('this.responsedata: ' + JSON.stringify(this.responsedata.data.arus_kas_operasi));
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
					//this.loading.chart = false;
				})
        },
	}
}
</script>


<style>
.table-financial-ratio th {
    font-weight: bold;
}

.table-financial-ratio td, th {
    padding: 6px 6px;
}
</style>
